const { componentsThemeManager } = require('./helpers/themeHelpers');

const components = import.meta.webpackContext('./components', {
  recursive: true,
  regExp: /index.js$/,
  mode: 'lazy',
  chunkName: '[request]',
  prefetch: true,
});

// all components must be in a folder with the component name, and have an index.js file
// e.g. ./descope-button/index.js
module.exports = components.keys().reduce((acc, key) => {
  // eslint-disable-next-line no-useless-escape
  const componentName = key.replace(/.*?([^\/]+)\/index\.js$/, '$1');

  if (componentName.endsWith('-internal')) {
    return acc;
  }

  acc[componentName] = () => components(key);

  return acc;
}, {});

module.exports.componentsThemeManager = componentsThemeManager;

module.exports['descope-address-field'] = () => import(/* webpackChunkName: "descope-address-field" */ /* webpackPrefetch: true */ '@descope-ui/descope-address-field');
module.exports['descope-apps-list'] = () => import(/* webpackChunkName: "descope-apps-list" */ /* webpackPrefetch: true */ '@descope-ui/descope-apps-list');
module.exports['descope-autocomplete-field'] = () => import(/* webpackChunkName: "descope-autocomplete-field" */ /* webpackPrefetch: true */ '@descope-ui/descope-autocomplete-field');
module.exports['descope-avatar'] = () => import(/* webpackChunkName: "descope-avatar" */ /* webpackPrefetch: true */ '@descope-ui/descope-avatar');
module.exports['descope-button'] = () => import(/* webpackChunkName: "descope-button" */ /* webpackPrefetch: true */ '@descope-ui/descope-button');
module.exports['descope-collapsible-container'] = () => import(/* webpackChunkName: "descope-collapsible-container" */ /* webpackPrefetch: true */ '@descope-ui/descope-collapsible-container');
module.exports['descope-combo-box'] = () => import(/* webpackChunkName: "descope-combo-box" */ /* webpackPrefetch: true */ '@descope-ui/descope-combo-box');
module.exports['descope-enriched-text'] = () => import(/* webpackChunkName: "descope-enriched-text" */ /* webpackPrefetch: true */ '@descope-ui/descope-enriched-text');
module.exports['descope-icon'] = () => import(/* webpackChunkName: "descope-icon" */ /* webpackPrefetch: true */ '@descope-ui/descope-icon');
module.exports['descope-image'] = () => import(/* webpackChunkName: "descope-image" */ /* webpackPrefetch: true */ '@descope-ui/descope-image');
module.exports['descope-link'] = () => import(/* webpackChunkName: "descope-link" */ /* webpackPrefetch: true */ '@descope-ui/descope-link');
module.exports['descope-list'] = () => import(/* webpackChunkName: "descope-list" */ /* webpackPrefetch: true */ '@descope-ui/descope-list');
module.exports['descope-list-item'] = () => import(/* webpackChunkName: "descope-list-item" */ /* webpackPrefetch: true */ '@descope-ui/descope-list-item');
module.exports['descope-outbound-apps'] = () => import(/* webpackChunkName: "descope-outbound-apps" */ /* webpackPrefetch: true */ '@descope-ui/descope-outbound-apps');
module.exports['descope-password-strength'] = () => import(/* webpackChunkName: "descope-password-strength" */ /* webpackPrefetch: true */ '@descope-ui/descope-password-strength');
module.exports['descope-recovery-codes'] = () => import(/* webpackChunkName: "descope-recovery-codes" */ /* webpackPrefetch: true */ '@descope-ui/descope-recovery-codes');
module.exports['descope-text'] = () => import(/* webpackChunkName: "descope-text" */ /* webpackPrefetch: true */ '@descope-ui/descope-text');
module.exports['descope-timer'] = () => import(/* webpackChunkName: "descope-timer" */ /* webpackPrefetch: true */ '@descope-ui/descope-timer');
module.exports['descope-timer-button'] = () => import(/* webpackChunkName: "descope-timer-button" */ /* webpackPrefetch: true */ '@descope-ui/descope-timer-button');
